<template>
  <Suspense>
    <component :is="getComponentType()" :content="getContent()"></component>
  </Suspense>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-facing-decorator';
import { DKReusablePage } from '@/models/DKReusablePage';
import { defineAsyncComponent } from 'vue';
import { StringMap } from '@/models/StringMap';
import { ContentType } from '@/store/app/models/ContentType';
import { DKReusablePageContent } from '@/models/DKReusablePageContent';

const DKEventsGrid = defineAsyncComponent(
  () => import('@/components/events/DKEventsGrid.vue')
);

@Component({
  components: {
    DKEventsGrid,
  },
})
export default class ReusablePageRenderer extends Vue {
  @Prop() reusablePage!: DKReusablePage;

  getComponentType() {
    return 'DK' + this.mapContentType(this.reusablePage.contentType);
  }

  getContent() {
    const content: DKReusablePageContent = {
      id: this.reusablePage.id,
      title: this.reusablePage.title,
      preTitle: this.reusablePage.preTitle,
      headerText: this.reusablePage.headerText,
      headerImage: this.reusablePage.headerImage,
    };
    return content;
  }

  mapContentType(value: string) {
    const map: StringMap = {
      [ContentType.Events]: 'EventsGrid',
    };

    return map[value];
  }
}
</script>
